/**
 * Intercept Vitals bundle "Add combo" button to open the theme's
 * quick-cart drawer instead of redirecting to /cart.
 *
 * How it works:
 * 1. Tracks clicks on the Vitals bundle button (.Vtl-UBBundleBoxAtcButton)
 * 2. Uses the Navigation API to intercept the /cart redirect Vitals triggers
 * 3. Notifies the theme via 'apps:product-added-to-cart' event
 * 4. Opens the quick-cart drawer by clicking the cart icon
 */
(function() {
  if (typeof navigation === 'undefined') return;

  var vitalsButtonClicked = false;

  document.addEventListener('click', function(e) {
    if (e.target.closest('.Vtl-UBBundleBoxAtcButton')) {
      vitalsButtonClicked = true;
      setTimeout(function() { vitalsButtonClicked = false; }, 10000);
    }
  }, true);

  navigation.addEventListener('navigate', function(event) {
    var url;
    try { url = new URL(event.destination.url); } catch(e) { return; }

    if (vitalsButtonClicked && /^\/cart\/?$/.test(url.pathname)) {
      event.preventDefault();
      vitalsButtonClicked = false;

      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));

      setTimeout(function() {
        var cartIcon = document.querySelector('a.header__icon-touch[href="/cart"]');
        if (cartIcon) cartIcon.click();
      }, 800);
    }
  });
})();

/**
 * Notify the theme when Vitals upsell-suggestions adds a product
 * so the quick-cart drawer refreshes automatically.
 */
(function() {
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.Vtl-Button')) return;
    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    }, 1000);
    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    }, 2500);
  }, true);
})();

/**
 * ─────────────────────────────────────────────────────────
 * Image Hero Split: Video blocks + Scroll button
 * Self-contained, no dependency on theme.js internals
 * ─────────────────────────────────────────────────────────
 */
(function () {
  "use strict";

  var SECTION_SELECTOR = '[data-section-type="image-hero-split"]';
  var BP_MOBILE = 720;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return [].slice.call((root || document).querySelectorAll(sel));
  }

  function isMobile() {
    return window.matchMedia("(max-width: " + (BP_MOBILE - 1) + "px)").matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  // ── Video: pause / play button ──

  function setupPauseButton(videoContainer) {
    var pause = qs(".video-pause", videoContainer);
    var video = videoContainer.getElementsByTagName("video")[0];
    if (!pause || !video) {
      console.log("[custom.js] pause btn or video missing", { pause: !!pause, video: !!video });
      return;
    }

    function doPause() {
      video.pause();
      pause.textContent = "Play video";
    }
    function doPlay() {
      video.play();
      pause.textContent = "Pause video";
    }

    if (prefersReducedMotion()) doPause();

    pause.addEventListener("click", function (e) {
      e.preventDefault();
      video.paused ? doPlay() : doPause();
    });
  }

  // ── Video: autoplay check (iOS low power mode) ──

  function checkAutoPlay(video, videoContainer) {
    if (!video) return;

    function handleAutoPlay() {
      if (video.paused) video.play();
    }
    function handlePlaying() {
      videoContainer.dataset.videoLoading = "false";
      window.removeEventListener("click", handleAutoPlay);
      window.removeEventListener("touchstart", handleAutoPlay);
      video.removeEventListener("playing", handlePlaying);
    }

    window.addEventListener("click", handleAutoPlay);
    window.addEventListener("touchstart", handleAutoPlay);
    video.addEventListener("playing", handlePlaying);
  }

  // ── Video: swap template (desktop / mobile) ──

  function updateVideoTemplate(videoContainer, videoType) {
    console.log("[custom.js] updateVideoTemplate:", videoType);

    var currentVideoEl = qs(".image-hero-split-item__current-video", videoContainer);
    var templateSelector = videoType === "mobile"
      ? "[data-mobile-video-template]"
      : "[data-default-video-template]";
    var videoTemplate = qs(templateSelector, videoContainer);

    if (!videoTemplate) {
      console.error("[custom.js] template NOT found:", templateSelector);
      return;
    }
    if (!currentVideoEl) {
      console.error("[custom.js] current-video container NOT found");
      return;
    }

    console.log("[custom.js] template innerHTML:", videoTemplate.innerHTML.substring(0, 200));

    var cloned = videoTemplate.content.cloneNode(true);
    currentVideoEl.innerHTML = "";
    currentVideoEl.appendChild(cloned);

    var liveVideo = currentVideoEl.querySelector("video");
    console.log("[custom.js] liveVideo:", liveVideo);

    if (liveVideo) {
      console.log("[custom.js] sources:", liveVideo.querySelectorAll("source").length, "src:", liveVideo.src);
      liveVideo.muted = true;
      liveVideo.playsInline = true;
      liveVideo.setAttribute("playsinline", "");

      setupPauseButton(videoContainer);

      var playPromise = liveVideo.play();
      if (playPromise) {
        playPromise.then(function () {
          console.log("[custom.js] video.play() OK");
        }).catch(function (err) {
          console.warn("[custom.js] video.play() rejected:", err.message);
        });
      }

      checkAutoPlay(liveVideo, videoContainer);

      if (liveVideo.paused) {
        console.log("[custom.js] video paused, setting loading=true");
        videoContainer.dataset.videoLoading = "true";
      }
    } else {
      console.error("[custom.js] NO <video> after appendChild. HTML:", currentVideoEl.innerHTML.substring(0, 300));
    }
  }

  // ── Video: init all video containers ──

  function initVideoBlocks(container) {
    var videoContainers = qsa("[data-video-container]", container);
    console.log("[custom.js] videoContainers:", videoContainers.length);

    videoContainers.forEach(function (vc, idx) {
      var hasVideo = vc.dataset.hasVideo === "true";
      var hasMobileVideo = vc.dataset.hasMobileVideo === "true";
      console.log("[custom.js] vc#" + idx, { hasVideo: hasVideo, hasMobileVideo: hasMobileVideo });

      if (hasMobileVideo) {
        updateVideoTemplate(vc, isMobile() ? "mobile" : "default");
        window.matchMedia("(max-width: " + (BP_MOBILE - 1) + "px)")
          .addEventListener("change", function () {
            updateVideoTemplate(vc, isMobile() ? "mobile" : "default");
          });
      } else if (hasVideo) {
        updateVideoTemplate(vc, "default");
      }
    });
  }

  // ── Scroll button ──

  function initScrollButton(container) {
    var scrollBtn = qs(".image-hero-split__scroll-btn", container);
    console.log("[custom.js] scrollBtn:", scrollBtn);
    if (!scrollBtn) return;

    console.log("[custom.js] scrollBtn dataset:", JSON.stringify(scrollBtn.dataset));

    scrollBtn.addEventListener("click", function () {
      console.log("[custom.js] scroll btn CLICKED");

      var scrollTarget = scrollBtn.dataset.scrollTarget;
      var scrollTargetId = (scrollBtn.dataset.scrollTargetId || "").replace(/^#/, "");
      var targetEl = null;

      console.log("[custom.js] target:", scrollTarget, "id:", scrollTargetId);

      if (scrollTarget === "custom" && scrollTargetId) {
        targetEl = document.getElementById(scrollTargetId)
          || document.getElementById("shopify-section-" + scrollTargetId)
          || qs('[data-section-id="' + scrollTargetId + '"]');
        console.log("[custom.js] custom target found:", !!targetEl);
      } else {
        var parentSection = container.closest(".shopify-section");
        if (parentSection) {
          targetEl = parentSection.nextElementSibling;
          console.log("[custom.js] next sibling:", targetEl);
        }
      }

      if (targetEl) {
        // Account for sticky header + announcement bar
        var stickyHeader = qs(".header__outer-wrapper");
        var headerOffset = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
        var y = targetEl.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        console.log("[custom.js] scrolling to:", y, "headerOffset:", headerOffset);
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        console.warn("[custom.js] NO scroll target found!");
      }
    });
  }

  // ── Init ──

  function initAllSections() {
    var sections = qsa(SECTION_SELECTOR);
    console.log("[custom.js] image-hero-split sections:", sections.length);

    sections.forEach(function (container) {
      if (container.dataset.customJsInit) return;
      container.dataset.customJsInit = "true";
      console.log("[custom.js] init section:", container.dataset.sectionId);
      initVideoBlocks(container);
      initScrollButton(container);
    });
  }

  if (document.readyState === "complete" || document.readyState === "interactive") {
    initAllSections();
  } else {
    document.addEventListener("DOMContentLoaded", initAllSections);
  }

  // Shopify theme editor support
  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) {
      section.dataset.customJsInit = "";
      initVideoBlocks(section);
      initScrollButton(section);
    }
  });
})();